import { Button } from 'design-system';

import type { MarkdownHeading } from './lib/useMarkdownHeadings';

type MonthlyRecapTableOfContentsProps = {
  headings: MarkdownHeading[];
  activeId: string | null;
  onSelect: (id: string) => void;
};

export const MonthlyRecapTableOfContents = ({
  headings,
  activeId,
  onSelect
}: MonthlyRecapTableOfContentsProps) => (
  <nav
    aria-label='Article sections'
    className='flex w-full flex-col gap-0.5 p-3'
  >
    <p className='px-1 pb-2 text-xs font-semibold text-muted-foreground'>IN THIS RECAP</p>

    {headings.map(heading => (
      <Button
        key={heading.id}
        aria-current={activeId === heading.id ? 'location' : undefined}
        className='h-auto justify-start whitespace-normal px-2 py-1.5 text-left text-xs'
        variant='ghost'
        onClick={() => {
          onSelect(heading.id);
        }}
      >
        {heading.label}
      </Button>
    ))}
  </nav>
);
